import React from 'react';
export const MetricsTestimonialsSection = () => {
  return <section className="bg-white py-10 px-5 sm:px-10 border-t-4 border-biosync" data-id="element-151">
      <div className="max-w-[1100px] mx-auto" data-id="element-152">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-16" data-id="element-153">
          <div className="border border-biosync/20 rounded-xl p-6 text-center shadow-sm" data-id="element-154">
            <div className="text-3xl sm:text-4xl font-bold text-biosync mb-2" data-id="element-155">
              +1.500
            </div>
            <div className="text-biosync-textSec text-sm sm:text-base" data-id="element-156">
              familias usan BIO-SYNC
            </div>
          </div>
          <div className="border border-biosync/20 rounded-xl p-6 text-center shadow-sm" data-id="element-157">
            <div className="text-3xl sm:text-4xl font-bold text-biosync mb-2" data-id="element-158">
              6+3
            </div>
            <div className="text-biosync-textSec text-sm sm:text-base" data-id="element-159">
              Módulos + Bonos incluidos
            </div>
          </div>
          <div className="border border-biosync/20 rounded-xl p-6 text-center shadow-sm" data-id="element-160">
            <div className="text-3xl sm:text-4xl font-bold text-biosync mb-2" data-id="element-161">
              4,9/5
            </div>
            <div className="text-biosync-textSec text-sm sm:text-base" data-id="element-162">
              calificación ⭐
            </div>
          </div>
          <div className="border border-biosync/20 rounded-xl p-6 text-center shadow-sm flex flex-col items-center justify-center" data-id="element-163">
            <div className="text-3xl sm:text-4xl font-bold text-biosync mb-2" data-id="element-164">
              🌎
            </div>
            <div className="text-biosync-textSec text-sm sm:text-base" data-id="element-165">
              Habla Hispana
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-166">
          <div className="bg-biosync-bgTest border border-biosync/20 rounded-2xl p-6 shadow-sm" data-id="element-167">
            <div className="flex items-center gap-3 mb-4" data-id="element-168">
              <div className="w-10 h-10 rounded-full bg-biosync text-white flex items-center justify-center font-bold text-lg" data-id="element-169">
                C
              </div>
              <div className="text-yellow-400 text-sm" data-id="element-170">⭐⭐⭐⭐⭐</div>
            </div>
            <p className="text-biosync-text italic mb-4 text-sm sm:text-base" data-id="element-171">
              "En dos semanas mi hijo empezó a usar técnicas de respiración
              solo. Sin que yo se lo recordara."
            </p>
            <div className="text-sm" data-id="element-172">
              <p className="font-bold text-biosync-text" data-id="element-173">
                — Claudia M., Buenos Aires
              </p>
              <p className="text-biosync-textSec" data-id="element-174">Madre de Tomás, 15 años</p>
            </div>
          </div>

          <div className="bg-biosync-bgTest border border-biosync/20 rounded-2xl p-6 shadow-sm" data-id="element-175">
            <div className="flex items-center gap-3 mb-4" data-id="element-176">
              <div className="w-10 h-10 rounded-full bg-biosync-lavanda text-biosync-text flex items-center justify-center font-bold text-lg" data-id="element-177">
                R
              </div>
              <div className="text-yellow-400 text-sm" data-id="element-178">⭐⭐⭐⭐⭐</div>
            </div>
            <p className="text-biosync-text italic mb-4 text-sm sm:text-base" data-id="element-179">
              "Pensé que era otro libro para leer y olvidar. BIO-SYNC tiene
              actividades concretas que mi hija hace sola. La diferencia se nota
              en casa."
            </p>
            <div className="text-sm" data-id="element-180">
              <p className="font-bold text-biosync-text" data-id="element-181">
                — Roberto S., Ciudad de México
              </p>
              <p className="text-biosync-textSec" data-id="element-182">
                Padre de Valentina, 14 años
              </p>
            </div>
          </div>

          <div className="bg-biosync-bgTest border border-biosync/20 rounded-2xl p-6 shadow-sm" data-id="element-183">
            <div className="flex items-center gap-3 mb-4" data-id="element-184">
              <div className="w-10 h-10 rounded-full bg-biosync-rosa text-biosync-text flex items-center justify-center font-bold text-lg" data-id="element-185">
                M
              </div>
              <div className="text-yellow-400 text-sm" data-id="element-186">⭐⭐⭐⭐⭐</div>
            </div>
            <p className="text-biosync-text italic mb-4 text-sm sm:text-base" data-id="element-187">
              "Mi hija pasó de explotar ante cualquier cosa a pedirme espacio
              para calmarse. En 3 semanas. No lo puedo creer todavía."
            </p>
            <div className="text-sm" data-id="element-188">
              <p className="font-bold text-biosync-text" data-id="element-189">— María L., Bogotá</p>
              <p className="text-biosync-textSec" data-id="element-190">Madre de Sofía, 16 años</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};